<template>
  <div
    class="m-auto inline-block h-6 w-6 animate-spin rounded-full border-2 border-solid align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
    role="status"
  ></div>
</template>

<script>
export default {};
</script>

<style></style>
